// extracted by mini-css-extract-plugin
export default {"form":"styles_form__XA2fG","icon":"styles_icon__2ZGuP","iconWrapper":"styles_iconWrapper__7BJPL"};